import React, { useState, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby";
import Navbar from "./navbar";
import Footer from "./footer";
import { findObject } from "../../utils/common";
import ExitIntent from "../../utils/ExitIntent";
import WelcomePopup from "../common/popup";

const OPTIONS = {
  threshold: 0,
  rootMargin: "0px 0px -250px 0px",
};

export default function Layout({
  children,
  footer = true,
  sitemap = true,
  navBg = "rgba(0,0,0,0.2)",
}) {
  const [arrow, setArrow] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (document.cookie.indexOf("exit_modal_seen=true") < 0) {
      const removeExitIntent = ExitIntent({
        threshold: 30,
        eventThrottle: 100,
        onExitIntent: () => {
          setShowPopup(true);
          let expiryDate = new Date(Date.now() + 1 * (1000 * 60 * 60 * 1));
          document.cookie =
            "exit_modal_seen" + "=true; expires=" + expiryDate.toUTCString();
        },
      });
      return () => {
        removeExitIntent();
      };
    }
  });

  useEffect(() => {
    const onScroll = (evt) => {
      let scrollTop = evt.target.documentElement.scrollTop;
      if (scrollTop > 800) {
        setArrow(true);
      } else {
        setArrow(false);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    // clean up code
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Intersection observer
  useEffect(() => {
    const sliders = document.querySelectorAll(".show");

    const appearOnScroll = new IntersectionObserver(function (
      entries,
      appearOnScroll
    ) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        } else {
          entry.target.classList.add("fadeIn");
          appearOnScroll.unobserve(entry.target);
        }
      });
    },
    OPTIONS);
    sliders.forEach((slider) => {
      appearOnScroll.observe(slider);
    });
  }, []);

  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  };

  const { sanitySitesettings } = useStaticQuery(
    graphql`
      query {
        sanitySitesettings {
          pageBuilder {
            ... on SanitySiteFooter {
              _type
              cc
              email
              phone1
              tel1
              phone2
              tel2
              footerbg {
                asset {
                  url
                }
              }
            }
            ... on SanitySiteHeader {
              _type
              menu {
                label
                path
                childs {
                  title
                  path
                  caption
                  img {
                    asset {
                      gatsbyImageData(
                        placeholder: BLURRED
                        formats: WEBP
                        fit: FILLMAX
                        height: 87
                        width: 125
                      )
                    }
                  }
                }
              }
            }
            ... on SanitySocialLinks {
              _type
              footerlogoSec {
                brandName
                logoType
                logoUrl
                svgs
                logo {
                  asset {
                    gatsbyImageData(
                      placeholder: BLURRED
                      fit: FILLMAX
                      formats: WEBP
                    )
                  }
                }
              }
            }
            ... on SanityPopup {
              _type
              description
              heading
              state
              image {
                asset {
                  gatsbyImageData(
                    fit: FILLMAX
                    placeholder: BLURRED
                    formats: WEBP
                    height: 350
                    width: 1000
                  )
                }
              }
              ctaButton {
                link
                title
                type
                variant
                formId
                downloadLink
              }
            }
          }
        }
      }
    `
  );

  let popupData = findObject(sanitySitesettings.pageBuilder, "popup");

  return (
    <div className="overflow-hidden">
      <Navbar
        header={findObject(sanitySitesettings.pageBuilder, "siteHeader")}
        navBg={navBg}
      />
      <main>{children}</main>
      {arrow && (
        <div className="fixed bottom-6 right-6 cursor-pointer">
          <button
            className="relative bg-[#006600] cursor-pointer hover:opacity-80 w-[50px] h-[50px] rounded opacity-70 flex items-center justify-center"
            onClick={scrollToTop}
            aria-label="btn-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="#ccc"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
              />
            </svg>
          </button>
        </div>
      )}
      {footer && (
        <Footer
          data={findObject(sanitySitesettings.pageBuilder, "siteFooter")}
          links={findObject(sanitySitesettings.pageBuilder, "socialLinks")}
          sitemap={sitemap}
        />
      )}

      {popupData && (
        <WelcomePopup
          onClose={() => setShowPopup(false)}
          value={showPopup}
          data={popupData}
        />
      )}

      <script
        src="https://app.wonderchat.io/scripts/wonderchat.js"
        data-name="wonderchat"
        data-address="app.wonderchat.io"
        data-id="cm4378zg400ez14pbmrzipnda"
        data-widget-size="normal"
        data-widget-button-size="normal"
        data-widget-offset-bottom="60px"
        data-widget-offset-bottom-mobile="60px"
        defer
      ></script>
    </div>
  );
}
